import { SearchCustomer, SearchReference, TransferEdit } from '@shared/interfaces/transfer';
import { Observable } from 'rxjs';

export const TRANSFER_REPOSITORY = 'TransfersRepository';

export interface TransfersRepository {
  getItems(): Observable<any>;

  getItemId(data: SearchReference): Observable<any>;

  getItemSearch(data: SearchCustomer): Observable<any>;

  validateEdit(data: SearchReference): Observable<any>;

  validateCancel(data: SearchReference): Observable<any>;

  validateReverse(data: SearchReference): Observable<any>;

  edit(transfer: TransferEdit): Observable<any>;

  editId(transfer: TransferEdit): Observable<any>;

  cancel(data: SearchReference): Observable<any>;

  reversed(data: SearchReference): Observable<any>;
}
